// extracted by mini-css-extract-plugin
export default {"cardOpen":"style_cardOpen__KMPev"};